<template>
  <div id="navbar" class="navbar flex flex-wrap w-full bg-white items-center relative">
    <div class="navbar__brand flex">
      <img
        class="navbar__logo"
        src="/static/logos/corbet.png"
        alt="Imprimerie Corbet"
      />
      <div class="navbar__contact flex items-center">
        <img class="phone-icon" src="/static/icons/phone-icon.png" />
        <a href="tel:+33238634440"><span class="text-3xl text-brown m-0">02 38 63 44 40</span></a>
      </div>
    </div>
    <nav
      class="navbar__desktop hidden md:flex flex-row font-bold text-nav text-brown ml-auto"
    >
      <router-link to="/" class="navbar__link homeLink">Accueil</router-link>

      <router-link to="/actu-corbet" class="navbar__link actuLink"
        >Actualités</router-link
      >

      <router-link to="/espaces-membres-corbet" class="navbar__link espacesLink"
        >Nos Espaces</router-link
      >

      <router-link to="/contact-corbet" class="navbar__link contactLink"
        >Contact</router-link
      >
    </nav>

    <div class="flex md:hidden ml-auto mr-10">
      <span @click="isOpen = !isOpen" class="text-xl text-brown cursor-pointer">
        <i class="fa fa-bars"></i>
      </span>
    </div>

    <nav
      v-if="isOpen"
      @click="isOpen = !isOpen"
      @mouseleave="mobileNavExit()"
      class="navbar__mobileNav flex flex-col w-full"
    >
      <router-link to="/" class="nav__link--mobile bg-brown w-70"
        >Accueil</router-link
      >
      <router-link
        to="/actu-corbet"
        class="nav__link--mobile bg-maquamarine w-90"
        >Actualités</router-link
      >
      <router-link
        to="/espaces-membres-corbet"
        class="nav__link--mobile bg-sandybrown w-55"
        >Nos Espaces</router-link
      >
      <router-link
        to="/contact-corbet"
        class="nav__link--mobile bg-mturquoise w-80"
        >Contact</router-link
      >
    </nav>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    mobileNavExit () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="css" scoped>
.navbar {
  min-height: 15vw;
  z-index: 1;
}

.navbar:after {
  content: "";
  min-height: inherit;
  font-size: 0;
}

.navbar__brand {
  max-height: 6.5vw;
  margin: 4% 4%;
}

.navbar__logo {
  margin: auto 0;
  max-height: 6.5vw;
}
.navbar__contact {
  flex: 1 0 100%;
  margin-left: 3%;
}
.phone-icon {
  max-height: 6.5vw;
}

.navbar__mobileNav {
  background-color: rgba(255, 255, 255, 0.5);
  font-size: 3vw;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 0.08ch;
}

.nav__link--mobile {
  padding: 1.2% 4%;
}

.navbar__link {
  text-decoration: none;
  margin-left: 3vw;
  color: #24211f;
}

.router-link-exact-active.homeLink {
  color: #990d44;
}

.router-link-active.actuLink {
  color: #5db99d;
}

.router-link-active.espacesLink {
  color: #fec86c;
}

.router-link-active.contactLink {
  color: #52cfeb;
}

@media screen and (min-width: 768px) {
  .navbar {
    min-height: 5vw;
    max-height: 5vw;
  }

  nav {
    margin-right: 5vw;
  }

  .navbar__brand {
    max-height: 3.5vw;
    margin: auto 4%;
  }

  .navbar__logo {
    min-height: 3.2vw;
    max-height: 3.2vw;
    max-width: unset;
  }

  .phone-icon {
    max-height: 2.5vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue